<p class="mb-0" *ngIf="textTranslationId || isTrial">
  <transloco
    id="e88469de-1356-483e-8a09-b97fc6d6bb2e"
    [key]="isTrial ? 'accountUi.registrationCompleteText.yourAccountHasBeenVerifiedAndTrialIsWaiting' : textTranslationId?.key"
    [params]="
      isTrial
        ? { emailClass: 'text-p-40 inline-flex max-w-full overflow-hidden', email: (email$ | async) ?? '', id: '0e7ec388-ec4b-4190-b331-f0d88429a8f9' }
        : textTranslationId?.params
    "
    [scope]="isTrial ? undefined : textTranslationId?.scope"></transloco>
</p>
